// extracted by mini-css-extract-plugin
module.exports = {"SocialIconsBox":"SocialLinks_SocialIconsBox__3wCm7","SocialIcon":"SocialLinks_SocialIcon__23rFe"};